/**
 * MIONZA Virtual Try-On
 * v2.4.1 - Direct to Camera + 2nd Product Image
 */

(function() {
  'use strict';

  // ========================================
  // CONFIGURATION
  // ========================================
  const CONFIG = {
    n8nUrl: 'https://mionza.app.n8n.cloud/webhook/78addd4f-180d-4b85-afcb-0c904f0cc15a',
    authMethod: 'none',
    authToken: '',
    hmacSecret: '',
    enableProcessing: true,
    debug: true,
    timeout: 50000
  };

  // ========================================
  // QUALITY TIPS BY PRODUCT TYPE
  // ========================================
  const QUALITY_TIPS = {
    necklace: 'Good lighting • Show shoulders • Center yourself',
    necklaces: 'Good lighting • Show shoulders • Center yourself',
    earring: 'Turn slightly • Clear ear view • Natural pose',
    earrings: 'Turn slightly • Clear ear view • Natural pose',
    ring: 'Flat hand • Centered frame • Steady hold',
    rings: 'Flat hand • Centered frame • Steady hold',
    bracelet: 'Extend arm • Show wrist • Keep hand relaxed',
    bracelets: 'Extend arm • Show wrist • Keep hand relaxed'
  };

  // ========================================
  // MAIN CLASS
  // ========================================
  class MionzaTryOn {
    constructor() {
      if (!document.getElementById('mionza-tryon-modal')) return;
      
      this.modal = document.getElementById('mionza-tryon-modal');
      this.trigger = document.getElementById('mionza-tryon-trigger');
      this.stream = null;
      this.capturedImage = null;
      this.resultImage = null;
      this.productData = {};
      this.facingMode = 'user';
      this.overlayUrls = window.MIONZA_OVERLAY_URLS || {};
      
      // Outfit selection
      this.outfits = {};
      this.selectedOutfit = null;
      this.outfitDrawerOpen = false;
      
      if (this.trigger) {
        this.init();
      }
    }

    async init() {
      this.getProductData();
      await this.loadOutfits();
      this.bindEvents();
      this.log('MIONZA Try-On initialized', this.productData);
    }

    getProductData() {
      // Raw product type
      let rawType = this.trigger.dataset.productType;
      
      // Normalize: Çoğulları tekile çevir
      const normalizeType = (type) => {
        const typeMap = {
          'necklaces': 'necklace',
          'earrings': 'earring',
          'rings': 'ring',
          'bracelets': 'bracelet'
        };
        return typeMap[type] || type;
      };
      
      // ✅ Parse product images array
      let productImages = [];
      try {
        productImages = JSON.parse(this.trigger.dataset.productImages || '[]');
      } catch (e) {
        this.log('Failed to parse product images:', e);
      }
      
      this.productData = {
        id: this.trigger.dataset.productId,
        handle: this.trigger.dataset.productHandle,
        type: normalizeType(rawType),
        title: this.trigger.dataset.productTitle,
        imageUrl: this.trigger.dataset.productImage,
        secondImageUrl: this.trigger.dataset.productImage2 || productImages[1] || null, // ✅ 2. fotoğraf
        allImages: productImages, // ✅ Tüm fotoğraflar
        variantId: this.trigger.dataset.variantId,
        metal: this.trigger.dataset.metal,
        price: this.trigger.dataset.price
      };
      
      this.log('Product data loaded:', {
        type: this.productData.type,
        hasSecondImage: !!this.productData.secondImageUrl,
        totalImages: productImages.length
      });
    }

    // ========================================
    // LOAD OUTFITS JSON
    // ========================================
    async loadOutfits() {
      try {
        const jsonUrl = window.MIONZA_OUTFITS_URL || CONFIG.outfitsJsonUrl;
        
        if (!jsonUrl) {
          this.log('No outfits JSON URL provided');
          return;
        }

        const response = await fetch(jsonUrl);
        const data = await response.json();
        
        this.outfits = data.outfits || {};
        this.log('Outfits loaded:', Object.keys(this.outfits));
        
      } catch (err) {
        this.log('Failed to load outfits:', err);
      }
    }

    bindEvents() {
      // Open modal
      this.trigger.addEventListener('click', () => {
        this.openModal();
        this.trackEvent('tryon_modal_opened');
      });

      // Close modal
      this.modal.querySelector('.modal-close').addEventListener('click', () => this.closeModal());
      this.modal.querySelector('.modal-backdrop').addEventListener('click', () => this.closeModal());

      // Consent checkbox
      const consent = document.getElementById('mionza-consent');
      const startBtn = document.getElementById('start-experience');
      consent.addEventListener('change', (e) => {
        startBtn.disabled = !e.target.checked;
        if (e.target.checked) {
          this.trackEvent('tryon_consent_accepted');
        }
      });

      // ✅ NAVIGATION - Direct to Camera
      startBtn.addEventListener('click', () => {
        this.startCamera();
        this.trackEvent('tryon_camera_started');
      });
      
      // Choose Outfit button
      document.getElementById('choose-outfit-btn').addEventListener('click', () => {
        this.toggleOutfitDrawer();
      });
      
      // Outfit drawer close
      document.getElementById('outfit-drawer-close').addEventListener('click', () => {
        this.closeOutfitDrawer();
      });
      
      // Outfit card click
      document.addEventListener('click', (e) => {
        if (e.target.closest('.outfit-card')) {
          this.selectOutfit(e.target.closest('.outfit-card'));
        }
      });
      
      document.getElementById('capture-photo').addEventListener('click', () => this.capturePhoto());
      document.getElementById('retake-photo').addEventListener('click', () => this.retake());
      document.getElementById('process-image').addEventListener('click', () => this.processImage());
      document.getElementById('try-another').addEventListener('click', () => this.retake());

      // Results
      document.getElementById('download-result').addEventListener('click', () => this.downloadResult());
      document.getElementById('share-result').addEventListener('click', () => this.shareResult());
      document.getElementById('add-to-bag-result').addEventListener('click', () => this.addToBag());

      // Switch camera
      const switchBtn = document.getElementById('switch-camera');
      if (this.isMobile()) {
        switchBtn.style.display = 'flex';
      }
      switchBtn.addEventListener('click', () => this.switchCamera());

      // ESC key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          if (this.outfitDrawerOpen) {
            this.closeOutfitDrawer();
          } else if (this.modal.classList.contains('active')) {
            this.closeModal();
          }
        }
      });
    }

    // ========================================
    // MODAL CONTROL
    // ========================================
    openModal() {
      this.modal.classList.add('active');
      document.body.style.overflow = 'hidden';
      this.showStep('privacy');
    }

    closeModal() {
      this.modal.classList.remove('active');
      document.body.style.overflow = '';
      this.stopCamera();
      this.clearImages();
      this.selectedOutfit = null;
      this.closeOutfitDrawer();
    }

    showStep(step) {
      document.querySelectorAll('.modal-step').forEach(s => s.classList.remove('active'));
      const targetStep = document.querySelector(`[data-step="${step}"]`);
      if (targetStep) {
        targetStep.classList.add('active');
        this.log('Showing step:', step);
      } else {
        this.log('ERROR: Step not found:', step);
      }
    }

    // ========================================
    // OUTFIT DRAWER
    // ========================================
    toggleOutfitDrawer() {
      if (this.outfitDrawerOpen) {
        this.closeOutfitDrawer();
      } else {
        this.openOutfitDrawer();
      }
    }

    openOutfitDrawer() {
      const drawer = document.getElementById('outfit-drawer');
      drawer.classList.add('active');
      this.outfitDrawerOpen = true;
      this.renderOutfitDrawer();
      this.trackEvent('tryon_outfit_drawer_opened');
    }

    closeOutfitDrawer() {
      const drawer = document.getElementById('outfit-drawer');
      drawer.classList.remove('active');
      this.outfitDrawerOpen = false;
    }

    renderOutfitDrawer() {
      const container = document.getElementById('outfit-drawer-grid');
      const outfitList = this.outfits[this.productData.type] || [];
      
      // Add "No Style" option
      const noStyleOption = {
        id: 'no-style',
        name: 'No Style',
        category: 'default',
        thumbnail: 'https://cdn.shopify.com/s/files/1/0567/4870/3914/files/no-style.png?v=1769255083',
        description: 'Use your own outfit',
        fullImage: null
      };
      
      const allOutfits = [noStyleOption, ...outfitList];

      container.innerHTML = allOutfits.map(outfit => `
        <div class="outfit-card ${this.selectedOutfit?.id === outfit.id ? 'selected' : ''} ${outfit.id === 'no-style' && !this.selectedOutfit ? 'selected' : ''}" data-outfit-id="${outfit.id}">
          <div class="outfit-thumbnail">
            <img src="${outfit.thumbnail}" alt="${outfit.name}" loading="lazy" />
            <div class="outfit-checkmark">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
            </div>
          </div>
          <div class="outfit-info">
            <h4>${outfit.name}</h4>
            <p>${outfit.description || outfit.category}</p>
          </div>
        </div>
      `).join('');
    }

    selectOutfit(card) {
      const outfitId = card.dataset.outfitId;
      
      if (outfitId === 'no-style') {
        this.selectedOutfit = null;
      } else {
        const outfitList = this.outfits[this.productData.type] || [];
        this.selectedOutfit = outfitList.find(o => o.id === outfitId);
      }

      // Update UI
      document.querySelectorAll('.outfit-card').forEach(c => c.classList.remove('selected'));
      card.classList.add('selected');
      
      // Update button text
      this.updateOutfitButtonText();
      
      // Close drawer
      setTimeout(() => {
        this.closeOutfitDrawer();
      }, 300);

      this.log('Outfit selected:', this.selectedOutfit?.name || 'No Style');
      this.trackEvent('tryon_outfit_selected', { 
        outfit: this.selectedOutfit?.id || 'no-style' 
      });
    }

    updateOutfitButtonText() {
      const btn = document.getElementById('choose-outfit-btn');
      const textSpan = btn.querySelector('.btn-text');
      
      if (this.selectedOutfit) {
        textSpan.textContent = this.selectedOutfit.name;
      } else {
        textSpan.textContent = 'Choose Outfit';
      }
    }

    // ========================================
    // CAMERA
    // ========================================
    async startCamera() {
      try {
        const constraints = {
          video: {
            facingMode: this.facingMode,
            width: { ideal: 1280, max: 1920 },
            height: { ideal: 720, max: 1080 }
          }
        };

        this.stream = await navigator.mediaDevices.getUserMedia(constraints);
        
        const video = document.getElementById('camera-stream');
        video.srcObject = this.stream;
        
        if (this.facingMode === 'user') {
          video.style.transform = 'scaleX(-1)';
        } else {
          video.style.transform = 'scaleX(1)';
        }
        
        this.showStep('camera');
        this.loadPNGOverlay();
        this.updateOutfitButtonText();
        
        this.log('Camera started');
        
      } catch (err) {
        this.log('Camera error:', err);
        alert('Camera access denied. Please allow camera permission.');
      }
    }

    stopCamera() {
      if (this.stream) {
        this.stream.getTracks().forEach(track => track.stop());
        this.stream = null;
      }
    }

    switchCamera() {
      this.facingMode = this.facingMode === 'user' ? 'environment' : 'user';
      this.stopCamera();
      this.startCamera();
    }

    // ========================================
    // PNG OVERLAY WITH PRODUCT-SPECIFIC SIZING
    // ========================================
    loadPNGOverlay() {
      const overlayContainer = document.getElementById('camera-overlay');
      const overlayUrl = this.getOverlayUrl(this.productData.type);
      
      if (!overlayUrl) {
        overlayContainer.innerHTML = '';
        return;
      }
      
      overlayContainer.setAttribute('data-product-type', this.productData.type);
      
      // Boyut ayarları
      const sizes = {
        necklace: { maxWidth: '95%', maxHeight: '95%' },
        earring: { maxWidth: '65%', maxHeight: '50%' },
        ring: { maxWidth: '100%', maxHeight: '100%' },
        bracelet: { maxWidth: '100%', maxHeight: '100%' }
      };
      
      const size = sizes[this.productData.type] || { maxWidth: '80%', maxHeight: '65%' };
      
      overlayContainer.innerHTML = `
        <img 
          src="${overlayUrl}" 
          class="overlay-png" 
          alt="Position guide"
          loading="eager"
          style="max-width: ${size.maxWidth}; max-height: ${size.maxHeight};"
        />
      `;
      
      const tipsElement = document.getElementById('quality-tips');
      if (tipsElement) {
        tipsElement.textContent = QUALITY_TIPS[this.productData.type] || QUALITY_TIPS.necklace;
      }
      
      overlayContainer.style.opacity = '0';
      setTimeout(() => {
        overlayContainer.style.opacity = '1';
      }, 100);
      
      this.log('PNG overlay loaded for:', this.productData.type);
    }

    getOverlayUrl(productType) {
      if (this.overlayUrls && this.overlayUrls[productType]) {
        return this.overlayUrls[productType];
      }
      this.log('No overlay URL found for product type:', productType);
      return null;
    }

    // ========================================
    // PHOTO CAPTURE WITH MIRROR FIX
    // ========================================
    capturePhoto() {
      const video = document.getElementById('camera-stream');
      const canvas = document.getElementById('capture-canvas');
      const ctx = canvas.getContext('2d');

      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      
      if (this.facingMode === 'user') {
        ctx.save();
        ctx.scale(-1, 1);
        ctx.drawImage(video, -canvas.width, 0, canvas.width, canvas.height);
        ctx.restore();
      } else {
        ctx.drawImage(video, 0, 0);
      }

      this.capturedImage = canvas.toDataURL('image/jpeg', 0.9);
      
      document.getElementById('preview-image').src = this.capturedImage;
      this.showStep('preview');
      this.stopCamera();
      
      this.log('Photo captured:', {
        width: canvas.width,
        height: canvas.height,
        facingMode: this.facingMode
      });
      
      this.trackEvent('tryon_photo_captured', {
        resolution: `${canvas.width}x${canvas.height}`,
        camera: this.facingMode
      });
    }

    retake() {
      this.clearImages();
      this.startCamera();
      this.log('Retaking photo');
      this.trackEvent('tryon_photo_retake');
    }

    // ========================================
    // PROCESSING
    // ========================================
    async processImage() {
      this.showStep('processing');
      this.animateProcessingHints();
      this.trackEvent('tryon_processing_started');

      if (CONFIG.enableProcessing && CONFIG.n8nUrl) {
        await this.sendToN8n();
      } else {
        await this.clientSideOverlay();
      }
    }

    async sendToN8n() {
      try {
        const timestamp = new Date().toISOString();
        const payload = {
          timestamp,
          product: {
            id: this.productData.id,
            handle: this.productData.handle,
            type: this.productData.type,
            title: this.productData.title,
            imageUrl: this.productData.imageUrl,
            secondImageUrl: this.productData.secondImageUrl, // ✅ 2. fotoğraf
            allImages: this.productData.allImages, // ✅ Tüm fotoğraflar
            variantId: this.productData.variantId,
            metal: this.productData.metal
          },
          customerPhoto: {
            dataUrl: this.capturedImage,
            deviceType: this.isMobile() ? 'mobile' : 'desktop',
            width: document.getElementById('capture-canvas').width,
            height: document.getElementById('capture-canvas').height
          },
          outfit: this.selectedOutfit ? {
            id: this.selectedOutfit.id,
            name: this.selectedOutfit.name,
            category: this.selectedOutfit.category,
            fullImage: this.selectedOutfit.fullImage,
            neckline: this.selectedOutfit.neckline || null
          } : null,
          consent: true,
          locale: document.documentElement.lang || 'en'
        };

        let headers = { 'Content-Type': 'application/json' };
        
        if (CONFIG.authMethod === 'header' && CONFIG.authToken) {
          headers['X-MIONZA-Auth'] = CONFIG.authToken;
        } else if (CONFIG.authMethod === 'hmac' && CONFIG.hmacSecret) {
          const signature = await this.generateHMAC(JSON.stringify(payload), timestamp);
          payload.signature = signature;
        }

        this.log('Sending to n8n:', {
          outfit: payload.outfit ? payload.outfit.name : 'No Style',
          secondImage: payload.product.secondImageUrl ? 'Available' : 'Not available',
          totalImages: payload.product.allImages.length
        });

        const response = await fetch(CONFIG.n8nUrl, {
          method: 'POST',
          headers: headers,
          body: JSON.stringify(payload),
          signal: AbortSignal.timeout(CONFIG.timeout)
        });

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        const result = await response.json();
        
        if (result.success && result.result?.imageDataUrl) {
          this.resultImage = result.result.imageDataUrl;
          this.displayResult();
          this.trackEvent('tryon_success');
        } else {
          throw new Error(result.error?.message || 'Processing failed');
        }

      } catch (err) {
        this.log('n8n error:', err);
        alert(`Error: ${err.message}\n\nTrying fallback...`);
        await this.clientSideOverlay();
      }
    }

    async clientSideOverlay() {
      return new Promise((resolve) => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        const customerImg = new Image();
        const productImg = new Image();

        customerImg.onload = () => {
          canvas.width = customerImg.width;
          canvas.height = customerImg.height;
          ctx.drawImage(customerImg, 0, 0);

          productImg.onload = () => {
            const positions = {
              necklace: { x: 0.5, y: 0.35, scale: 0.20 },
              earring: { x: 0.70, y: 0.25, scale: 0.12 },
              ring: { x: 0.5, y: 0.65, scale: 0.15 },
              bracelet: { x: 0.5, y: 0.60, scale: 0.18 }
            };

            const pos = positions[this.productData.type] || positions.necklace;
            const w = productImg.width * pos.scale;
            const h = productImg.height * pos.scale;

            ctx.globalAlpha = 0.9;
            ctx.drawImage(productImg, 
              canvas.width * pos.x - w/2, 
              canvas.height * pos.y - h/2, 
              w, h
            );

            this.resultImage = canvas.toDataURL('image/jpeg', 0.9);
            this.displayResult();
            resolve();
          };

          productImg.src = this.productData.imageUrl;
        };

        customerImg.src = this.capturedImage;
      });
    }

    displayResult() {
      document.getElementById('result-image').src = this.resultImage;
      document.getElementById('result-price').textContent = '$' + this.productData.price;
      this.showStep('result');
      this.log('Result displayed');
    }

    // ========================================
    // RESULT ACTIONS
    // ========================================
    downloadResult() {
      const link = document.createElement('a');
      link.href = this.resultImage;
      link.download = `mionza-tryon-${this.productData.handle}-${Date.now()}.jpg`;
      link.click();
      this.trackEvent('tryon_downloaded');
    }

    async shareResult() {
      if (navigator.share) {
        try {
          const blob = await (await fetch(this.resultImage)).blob();
          const file = new File([blob], 'mionza-tryon.jpg', { type: 'image/jpeg' });
          
          await navigator.share({
            files: [file],
            title: `Try-On: ${this.productData.title}`
          });
          
          this.trackEvent('tryon_shared');
        } catch (err) {
          if (err.name !== 'AbortError') {
            this.downloadResult();
          }
        }
      } else {
        this.downloadResult();
      }
    }

    addToBag() {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: this.productData.variantId,
          quantity: 1
        })
      })
      .then(() => {
        this.closeModal();
        this.trackEvent('tryon_add_to_cart');
        window.location.href = '/cart';
      })
      .catch(() => {
        alert('Failed to add to cart');
      });
    }

    // ========================================
    // UTILITIES
    // ========================================
    async generateHMAC(data, timestamp) {
      const encoder = new TextEncoder();
      const key = await crypto.subtle.importKey(
        'raw',
        encoder.encode(CONFIG.hmacSecret),
        { name: 'HMAC', hash: 'SHA-256' },
        false,
        ['sign']
      );

      const signature = await crypto.subtle.sign(
        'HMAC',
        key,
        encoder.encode(timestamp + data)
      );

      return Array.from(new Uint8Array(signature))
        .map(b => b.toString(16).padStart(2, '0'))
        .join('');
    }

    animateProcessingHints() {
      const hints = document.querySelectorAll('.processing-hints .hint');
      let index = 0;

      const interval = setInterval(() => {
        hints.forEach(h => h.classList.remove('active'));
        if (index < hints.length) {
          hints[index].classList.add('active');
          index++;
        } else {
          clearInterval(interval);
        }
      }, 1500);
    }

    clearImages() {
      this.capturedImage = null;
      this.resultImage = null;
      
      const previewImg = document.getElementById('preview-image');
      const resultImg = document.getElementById('result-image');
      if (previewImg) previewImg.src = '';
      if (resultImg) resultImg.src = '';
    }

    isMobile() {
      return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    }

    trackEvent(eventName, data = {}) {
      if (typeof gtag !== 'undefined') {
        gtag('event', eventName, {
          ...data,
          product_type: this.productData.type,
          product_id: this.productData.id
        });
      }
      this.log('Event:', eventName, data);
    }

    log(...args) {
      if (CONFIG.debug) {
        console.log('[MIONZA Try-On]', ...args);
      }
    }
  }

  // ========================================
  // INITIALIZE
  // ========================================
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.mionzaTryOn = new MionzaTryOn();
    });
  } else {
    window.mionzaTryOn = new MionzaTryOn();
  }

})();